import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { getEquipmentMakeModelAndType, getShipEquipmentMakeModelAndType } from "../Actions/EquipmentManagementAPI";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import $ from "jquery";
import { toast } from "react-toastify";
import { Paginator } from "primereact/paginator";
import axios from "axios";
import API from "../helpers/api";
import { confirmationAlert, successAlert } from "../alerts";
import { getLookupList } from "../Actions/lookupAPI";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { confirmAlert } from "react-confirm-alert";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));

const PlanType = Object.freeze({
    CONTRACT: 1,
    ADDON: 2,
    ADHOC: 3
});

let InitialZone = {
    "cost": [
        {
            "zoneId": 0,
            "cost": 0
        }
    ],
    "actionBy": "",
    "isDelete": false,
    "equipmentId": 0,
    "equipmentName": ""
}

const PAGESIZE = 20;

class ShipCostManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tableData: {},
            zoneLookup: [],
            currentRowIdentifier: NaN,
            first: 0,
            rowAffected: false,
            pagination: {
                CONTRACT: {
                    "totalcount": 10,
                    "pageSize": 25,
                    "currentPage": 1,
                    "totalPages": 7,
                    "hasNext": true,
                    "hasPrevious": false
                },
                ADDON: {
                    "totalcount": 20,
                    "pageSize": 25,
                    "currentPage": 1,
                    "totalPages": 7,
                    "hasNext": true,
                    "hasPrevious": false
                },
                ADHOC: {
                    "totalcount": 75,
                    "pageSize": 25,
                    "currentPage": 1,
                    "totalPages": 7,
                    "hasNext": true,
                    "hasPrevious": false
                }
            },
            first: {
                CONTRACT: 0,
                ADDON: 0,
                ADHOC: 0
            },
            equipemntConfigTypeList: [],
            equipemntZoneList: [],
            tableEquipmentArray: [],
            equipmentCostList: [],
            currentTabData: {},
            actionBy: JSON.parse(localStorage.getItem("currentUser"))?.email,
            tableRowAffected: false,
            serviceTypeOptions: []
        };
    }

    componentDidMount() {
        this.getEquipmentType();
        this.props.dispatch({ type: "SubBannerTitle", data: "Cost Management" });
        // this.getLookupData();
        this.props.dispatch({ type: "SubBannerTitle", data: "Cost Management" })
        // jquery events
        // var _this = this;
        // $(document).on("click", ".equipment-report-table tr", function () {
        //   let rowIdentifier = $(this).attr("data-identifier");
        //   let tableType = $(this).attr('data-table-identifier');
        // // let hasInput = $(this).find("input").length;
        // if (rowIdentifier != _this.state.currentRowIdentifier) {
        //   if (_this.state.rowAffected)
        //     _this.postData(tableType, _this.state.currentRowIdentifier);
        //   if (_this.state.currentRowIdentifier)
        //     _this.handleEdit(_this.state.currentRowIdentifier, false, tableType)
        //   _this.setState({
        //     currentRowIdentifier: rowIdentifier,
        //     rowAffected: false
        //   })
        // }
        // })
    }

    getEquipmentType = () => {
        let url = `${API.equipmentLookups}?lookupType=${"EquipmentCategoryType"}`;
        let data = {};
        let dataTypeArray = [];
        axios.get(url).then((response) => {
            if (response.data?.length > 0) {
                this.setState({ equipemntConfigTypeList: response.data, currentTabData: response.data[0] });
                if (response.data?.length > 0) {
                    const dataArray = response.data.filter(r => r.lookUpName?.toLowerCase() == "addon" || r.lookUpName?.toLowerCase() == "mandate")
                    dataArray.map(r => (
                        dataTypeArray.push(r.lookUpId)
                    ))
                }
                const { match, dispatch } = this.props;
                const { params } = match;
                const { id } = params;
                data = {
                    equipmentId: 0,
                    makename: "",
                    modelname: "",
                    typeId: 0,
                    isBoth: true,
                    ShipEquipmentId: id
                };
                console.log(data);
                let searchData = {
                    LookUpToSearch: "intervals",
                    LookUpName: "",
                    PageNumber: 1,
                    PageSize: 20
                };
                this.props.dispatch(getShipEquipmentMakeModelAndType(data));
                this.props.dispatch(getLookupList(searchData));
            }
        });
        let url1 = `${API.equipmentLookups}?lookupType=${"contract type"}`;
        axios.get(url1).then((response) => {
            let findId = response.data?.filter((item) => item.lookUpName === "FZM")[0]?.lookUpId;
            let url2 = `${API.equipmentLookups}?lookupType=${"plan type"}&parentId=${findId}`;
            axios.get(url2).then((response) => {
                let zoneData = [];
                const dataArray = response.data?.map((item) => (
                    zoneData.push({
                        "zoneId": item.lookUpId,
                        "cost": 0
                    })
                ));
                this.setState({
                    equipemntZoneList: response.data,
                    equipmentCostList: zoneData
                });
                this.getData(this.state.currentTabData?.lookUpId, this.state.currentTabData);
            });
        });
    }

    getData = (equip, item, tabChange) => {
        this.setState({
            currentTabData: item,
            tableEquipmentArray: []
        })
        if (tabChange == true) {
            const { match, dispatch } = this.props;
            const { params } = match;
            const { id } = params;
            let data = {
                equipmentId: 0,
                makename: "",
                modelname: "",
                typeId: 0,
                isBoth: true,
                ShipEquipmentId: id
            };
            this.props.dispatch(getShipEquipmentMakeModelAndType(data));
        }
        // let url = `${API.zoneCostList}?equipmentType=${equip}&PageNumber=${pageNumber || 1}&PageSize=${PAGESIZE}`;
        const { match, dispatch } = this.props;
        const { params } = match;
        const { id } = params;
        let url = `${API.ShipzoneCostList}?equipmentType=${equip}&shipId=${id}`;
        axios.get(url)
            .then((response) => {
                this.setState({

                }, () => {
                    this.transFormJSON(response.data, equip);
                })
            })
            .catch((error) => {
                console.log(error);
            })
    }

    // postData = (tableIdentier, rowIdentifier) => {
    //   let getTableData = this.state.tableData[tableIdentier];
    //   if (getTableData?.length > 0) {
    //     let getRow = getTableData.filter(x => x.identifier === rowIdentifier);
    //     let zoneCost = [];
    //     if (getRow.length > 0) {
    //       getRow = getRow[0];
    //       Object.keys(this.state.zoneObj).forEach(zoneName => {
    //         zoneCost.push(getRow[zoneName]);
    //       })
    //       let meta = {
    //         cost: zoneCost,
    //         actionBy: currentuser.email,
    //         equipmentId: getRow.equipmentId
    //       };

    //       let url = `${API.costConfig}`;
    //       axios
    //         .post(url, meta)
    //         .then((response) => {
    //           toast.success('Added Successfully', {
    //             position: "top-right",
    //             autoClose: 5000,
    //             hideProgressBar: true,
    //             closeOnClick: true,
    //             pauseOnHover: true,
    //             draggable: true,
    //             progress: undefined,
    //           });
    //         })
    //         .catch((error) => {
    //           console.error(error);
    //           toast.error("Failed", {
    //             position: "top-right",
    //             autoClose: 5000,
    //             hideProgressBar: true,
    //             closeOnClick: true,
    //             pauseOnHover: true,
    //             draggable: true,
    //             progress: undefined,
    //           });
    //         });
    //     }
    //   }
    // }

    handleEdit = (_identifier, _isEdit, ele) => {
        let data = this.state.tableEquipmentArray;
        data.forEach((item, index) => {
            if (index < data.length - 1) {
                item.isEdit = false;
            }
        });
        let index = data.findIndex(x => x.identifier == _identifier);
        let obj = {
            // equipmentId: ele.equipmentId,
            shipEquipmentId: ele.shipEquipmentId,
            equipmentName: ele?.equipmentName,
            equipmentValue: this.props.EquipmentDropdownList?.filter((item) => item.shipEquipmentId === ele.shipEquipmentId)[0],
            isEdit: _isEdit
        }
        if (index > -1) {
            let newItem = { ...data[index], ...obj };
            let newtableData = data;
            newtableData[index] = newItem;
            this.setState({
                tableEquipmentArray: newtableData
            })
        }
    }

    confirmAction = (result) => {
        console.log(result, "result")
    }

    cancelAction = (result) => {
        console.log(result, "result")
    }


    confirmDelete = (ele, ind) => {
        const { t } = this.props;
        confirmAlert({
            message: `${t("confirmAlertMessage.DeleteMsg")}`,
            buttons: [
                {
                    label: `${t("confirmAlertMessage.Yes")}`,
                    onClick: () => {
                        this.handleDeleteData(ele, ind)
                    },
                },
                {
                    label: `${t("confirmAlertMessage.No")}`,
                    onClick: () => { },
                },
            ],
        });
    }

    handleDeleteData = (ele, rowIndex) => {
        const { t } = this.props;
        // confirmationAlert("Confirmation", "Do you want to delete this equipment?", "warning", "Yes", "No", this.confirmAction(), this.cancelAction());
        let data = this.state.tableEquipmentArray;
        let index = data.findIndex(x => x.identifier == ele.identifier);
        let obj = {
            isDelete: true
        }
        if (index > -1) {
            let newItem = { ...data[index], ...obj };
            let dataItem = {};
            dataItem = {
                "cost": newItem.cost,
                "actionBy": this.state.actionBy,
                "isDelete": newItem.isDelete,
                // "equipmentId": newItem.equipmentId,
                "shipEquipmentId": newItem.shipEquipmentId,
                "equipmentName": newItem.equipmentName,
                "serviceTypes": newItem.serviceTypes,
                "equipmentContractTypeId": this.state.currentTabData?.lookUpId ?? 0
            }
            let url = `${API.ShipcostConfig}`;
            axios
                .post(url, dataItem)
                .then((response) => {
                    toast.success(`${t("CommonText.CommonDelete")}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    })
                })

                .catch((error) => {
                    console.error(error);
                });
            let newtableData = data;
            newtableData[index] = newItem;
            newtableData = newtableData.filter(item => item.shipEquipmentId !== ele?.shipEquipmentId)
            this.setState({
                tableEquipmentArray: newtableData,
                // tableRowAffected: true
            })
        }
    }

    handleInputChangeData = (event, _identifier, id, value) => {
        let _tableData = this.state.tableEquipmentArray;
        let obj = []
        if (value) {
            // let equipmentExist = _tableData.findIndex(x => x.equipmentId == id);
            // obj = {
            //   equipmentId: equipmentExist > -1 ? 0 : id,
            //   equipmentName: equipmentExist > -1 ? "" : value.name,
            //   equipmentValue: equipmentExist > -1 ? {} : value
            // }
            // if (equipmentExist > -1) {
            //   toast.error("Equipment already selected", {
            //     position: "top-right",
            //     autoClose: 3000,
            //     hideProgressBar: true,
            //     closeOnClick: true,
            //     pauseOnHover: true,
            //     draggable: true,
            //     progress: undefined,
            //   });
            // }
            // else {
            obj = {
                shipEquipmentId: id,
                equipmentName: value?.name,
                equipmentValue: value
            }
            let index = _tableData.findIndex(x => x.identifier == _identifier);
            if (index > -1) {
                let newItem = { ..._tableData[index], ...obj };
                _tableData[index] = newItem;
                if (value) {
                    let equipmentValidation = _tableData.filter(x_x => !x_x.shipEquipmentId);
                    if (equipmentValidation.length == 0) {
                        _tableData.push({
                            identifier: (Math.random() + 1).toString(36).substring(7),
                            shipEquipmentId: 0,
                            equipmentName: "",
                            equipmentValue: {},
                            isEdit: true,
                            isDelete: false,
                            cost: this.state.equipmentCostList
                        })
                    }
                }
                this.setState({
                    tableEquipmentArray: _tableData,
                    // tableRowAffected: true
                });
            }
            // }
        }
    }


    handleInputChangeType = (event, _identifier, value, itemData) => {
        let _tableData = this.state.tableEquipmentArray;
        const serviceTypeIds = _tableData?.filter(item => item.identifier !== _identifier && item.shipEquipmentId == itemData.shipEquipmentId)?.flatMap(item => item.serviceTypes?.map(service => service.serviceTypeId));
        if (value) {
            const filteredServiceTypes = value?.filter(service => !serviceTypeIds.includes(service.serviceTypeId));
            console.log(filteredServiceTypes);
            let index = _tableData.findIndex(x => x.identifier == _identifier);
            let obj = {
                serviceTypes: filteredServiceTypes
            }
            if (index > -1) {
                let newItem = { ..._tableData[index], ...obj };
                let newtableData = _tableData;
                newtableData[index] = newItem;
                this.setState({
                    tableEquipmentArray: _tableData,
                    // tableRowAffected: true
                });
            }
        }
    }

    // handleBlueServiceType = (event, _identifier, value, item) => {
    //   this.handleBlurData(item, true);
    // }

    handleBlurData = (item, changeType) => {
        // if ((item?.equipmentId > 0 && this.state.tableRowAffected == true) || changeType == true) {
        //   this.setState({
        //     tableRowAffected: false
        //   })
        let dataArray = this.state.tableEquipmentArray;
        dataArray.forEach((item, index) => {
            if (index < dataArray.length - 1) {
                item.isEdit = false;
            }
        });
        let index = dataArray.findIndex(x => x.identifier == item.identifier);
        let obj = {
            isEdit: false
        }
        if (index > -1) {
            let newItem = { ...dataArray[index], ...obj };
            let newtableData = dataArray;
            newtableData[index] = newItem;
            this.setState({
                tableEquipmentArray: newtableData
            })
        }
        let data = {};
        // const prepareArray = this.state.tableEquipmentArray?.map(x => (
        //   x.equipmentId > 0 &&
        //   data.push({
        data = {
            "cost": item.cost,
            "actionBy": this.state.actionBy,
            "isDelete": item.isDelete,
            "shipEquipmentId": item.shipEquipmentId,
            // "equipmentId": item.equipmentId,
            "equipmentName": item.equipmentName,
            "serviceTypes": item.serviceTypes,
            "equipmentContractTypeId": this.state.currentTabData?.lookUpId ?? 0
        }
        //   })
        // ))
        let url = `${API.ShipcostConfig}`;
        axios
            .post(url, data)
            .then((response) => {
            })
            .catch((error) => {
                console.error(error);
            });
        // }
    }

    // handleInputChangeZoneData = (e, ele, x, ind) => {
    //   let newCost = e.target.value;
    //   const data = this.state.tableEquipmentArray?.map((item, index) => (
    //     console.log(index, ind),
    //     (index === ind) ?
    //       item?.cost?.map((dataId) => (
    //         dataId.zoneId === x.zoneId ? (dataId.cost = parseInt(newCost), newCost = "") : <></>
    //       )) : <></>
    //   ))
    //   this.setState({
    //     tableEquipmentArray: this.state.tableEquipmentArray,
    //     tableRowAffected: true
    //   }, () => {
    //     console.log(this.state.tableEquipmentArray)
    //   })
    // }

    handleInputChangeZoneData = (e, ele, x, ind) => {
        // Extract the new cost from the event
        let newCost = parseInt(e.target.value);

        // Create a new array to avoid direct mutation
        const updatedTableEquipmentArray = this.state.tableEquipmentArray.map((item, index) => {
            if (index === ind) {
                // Update the cost for the specific zoneId in the matched row
                const updatedCost = item.cost.map(costItem =>
                    costItem.zoneId === x.zoneId ? { ...costItem, cost: newCost } : costItem
                );

                // Return the updated item
                return { ...item, cost: updatedCost };
            } else {
                // Return the item as is if not matched
                return item;
            }
        });
        this.setState({
            tableEquipmentArray: updatedTableEquipmentArray,
            // tableRowAffected: true
        }, () => {
        });
    }

    // handleInputChange = (event, tableType, _identifier, id, value) => {
    //   let obj = {};
    //   if (value) {
    //     let equipmentExist = this.state.tableData[tableType].findIndex(x => x.equipmentId == id);
    //     obj = {
    //       equipmentId: equipmentExist > -1 ? 0 : id,
    //       equipmentName: equipmentExist > -1 ? "" : value.name,
    //       equipmentValue: equipmentExist > -1 ? {} : value
    //     }
    //     if (equipmentExist > -1) {
    //       toast.error("Equipment already selected", {
    //         position: "top-right",
    //         autoClose: 3000,
    //         hideProgressBar: true,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //       });
    //     }
    //   } else {
    //     obj[event.target.name] = {
    //       zoneId: id,
    //       cost: parseInt(event.target.value)
    //     }
    //   }
    //   let _tableData = this.state.tableData[tableType];
    //   let index = _tableData.findIndex(x => x.identifier == _identifier);
    //   if (index > -1) {
    //     let newItem = { ..._tableData[index], ...obj };
    //     _tableData[index] = newItem;
    //     /* Adding new row, if all of the row equipment have value */
    //     if (value) {
    //       let equipmentValidation = _tableData.filter(x_x => !x_x.equipmentId);
    //       if (equipmentValidation.length == 0) {
    //         _tableData.push({
    //           identifier: (Math.random() + 1).toString(36).substring(7),
    //           equipmentId: 0,
    //           equipmentName: "",
    //           equipmentValue: {},
    //           isEdit: true,
    //           ...this.state.zoneObj
    //         })
    //       }
    //     }
    //     let _stateTableData = { ...this.state.tableData, [tableType]: _tableData };
    //     this.setState({
    //       tableData: _stateTableData,
    //       rowAffected: true
    //     });
    //   }
    // }

    // getLookupData = async () => {
    //   // equipment list
    //   const { dispatch } = this.props;
    //   axios
    //     .get(`${API.getZoneList}`)
    //     .then((response) => {
    //       let _zoneObj = {};
    //       response.data.forEach(zone => {
    //         _zoneObj[zone.value] = { zoneId: zone.id, cost: 0 };
    //       });
    //       this.state.zoneObj = _zoneObj;
    //       this.state.zoneLookup = response.data;
    //       this.setState({}, () => {
    //         this.getData("CONTRACT");
    //       });
    //     })
    //     .catch((error) => {
    //       console.log(error)
    //     });

    //   let data = {
    //     equipmentId: 0,
    //     makename: "",
    //     modelname: "",
    //   };
    //   dispatch(getEquipmentMakeModelAndType(data))
    // }

    transFormJSON = (resData, tableIdentier) => {
        let data = [];
        // const _zoneObj = this.state._zoneObj;
        const _zoneObj = this.state.equipemntZoneList;
        let combined = [];
        let costObj = {};
        if (resData.length > 0) (
            data = resData?.map(x => (
                _zoneObj.map(lookUp => (
                    costObj = x.cost?.find(cost => cost.zoneId === lookUp.lookUpId),
                    combined.push({
                        zoneId: lookUp.lookUpId,
                        cost: costObj ? costObj.cost : 0,
                        equipmentZoneCostId: costObj.equipmentZoneCostId
                    })
                )),
                x.cost = combined,
                x.identifier = (Math.random() + 1).toString(36).substring(7),
                x.shipEquipmentId = x.shipEquipmentId,
                x.equipmentName = x.equipmentName,
                x.equipmentValue = {},
                x.serviceTypes = x.serviceTypes,
                x.isEdit = false,
                x.isDelete = false,
                x.APIData = true,
                combined = []
            )
            )
        )
        this.setState({
            tableEquipmentArray: resData
        }, () => {
            this.addNewObject();
        })
    }

    addNewObject = () => {
        const { tableEquipmentArray } = this.state;
        let newArray = [{
            cost: this.state.equipmentCostList,
            identifier: (Math.random() + 1).toString(36).substring(7),
            shipEquipmentId: 0,
            equipmentName: "",
            equipmentValue: {},
            serviceTypes: [],
            isEdit: true,
            isDelete: false,
            APIData: true
        }]
        const combinedArray = [...tableEquipmentArray, ...newArray];
        this.setState({ tableEquipmentArray: combinedArray });
    }
    renderedit(props) {
        return (
            <Popover id="history-tooltip" {...props}>
                <Popover.Content>
                    <label style={{ padding: "0px 10px" }}>{this.props.t("IntervelScreen.Edit")}</label>
                </Popover.Content>
            </Popover>
        );
    }
    rendersave(props) {
        return (
            <Popover id="history-tooltip" {...props}>
                <Popover.Content>
                    <label style={{ padding: "0px 10px" }}>{this.props.t("EditEquipmentScreenContent.Save")}</label>
                </Popover.Content>
            </Popover>
        );
    }
    renderdelete(props) {
        return (
            <Popover id="history-tooltip" {...props}>
                <Popover.Content>
                    <label style={{ padding: "0px 10px" }}>{this.props.t("CommonText.Delete")}</label>
                </Popover.Content>
            </Popover>
        );
    }

    shipManagement(item) {
        const { dispatch } = this.props;
        this.props.dispatch({ type: "ShowSidePan", data: false });
        this.props.history.push(`/Home/ShipManagement`);
        window.scrollTo(0, 0);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const {
            dispatch,
            LookupList,
        } = nextProps;
        if (LookupList?.data?.length > 0 && prevState?.serviceTypeOptions?.length == 0) {
            prevState.serviceTypeOptions = LookupList?.data?.map((r) => {
                return {
                    "serviceTypeId": r.lookUpId,
                    "serviceType": r.lookUpName
                }
            })
        }
    }

    render() {
        const {
            t,
            EquipmentDropdownList,
            LookupList
        } = this.props;

        return (
            <div className="full-height">
                <div className="pt-3">
                    <div className="row mt-3">
                        <div className="col-lg-12">
                            <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mb-2"
                                onClick={() => this.shipManagement()}
                                style={{ display: 'inline-flex', alignItems: 'center' }}
                            >
                                <span style={{ marginTop: '-1px' }}>&larr;</span> {t("CommonText.Return")}
                            </button>
                            <div className="panel-box">
                                <div
                                    className="card MM-card-header"
                                    style={{ backgroundColor: "white", border: "0px" }}
                                >
                                    <div className="card-body">
                                        <h5
                                            className="card-title ml-2 mt-2 d-inline-block"
                                            style={{ color: "092a51" }}
                                        >
                                            {t("ServiceBudgetHistory.EquipmentZoneCostManagement")}
                                        </h5>
                                    </div>
                                </div>
                                <div className="search-filter-box">
                                    <ul className="nav nav-tabs" id="noteTab" role="tablist">
                                        {this.state.equipemntConfigTypeList.length > 0 && this.state.equipemntConfigTypeList?.map((item) => (
                                            (item.lookUpName?.toLowerCase() === "addon" || item.lookUpName?.toLowerCase() === "mandate") &&
                                            <li className="nav-item">
                                                <a
                                                    className={this.state.currentTabData?.lookUpId === item.lookUpId ? "nav-link active" : "nav-link"}
                                                    id={item.lookUpName}
                                                    data-toggle="tab"
                                                    href={"#" + item.lookUpName}
                                                    role="tab"
                                                    aria-controls={item.lookUpName}
                                                    aria-selected="true"
                                                    onClick={() => this.getData(item.lookUpId, item, true)}
                                                >
                                                    <h6 className="m-0 text-capitalize">{item.lookUpName}</h6>
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                    <div className="tab-content" id="myTabContent">
                                        <div
                                            className="tab-pane fade show active pb-3"
                                        // id="home"
                                        // role="tabpanel"
                                        // aria-labelledby="home-tab"
                                        >
                                            <div className="equip-type-wrapper min-hei-54">
                                                <table className="table equipment-report-table border-0" id="myTable">
                                                    <thead className="">
                                                        <tr>

                                                            <th scope="col">{t("ShipEquipmentStatusScreen.Equipment")}</th>
                                                            <th scope="col">{t("content.Servicetype")}</th>
                                                            {
                                                                this.state.equipemntZoneList?.length > 0 && this.state.equipemntZoneList.map((x, i) => {

                                                                    return <th scope="col">{x.lookUpName}</th>
                                                                })
                                                            }
                                                            <th scope="col" style={{ textAlign: 'center' }}>{t("VendorManagementScreenContent.Action")}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.tableEquipmentArray?.length > 0 && this.state.tableEquipmentArray?.map((ele, ind) => (
                                                            <tr data-index={ind} data-identifier={ele.identifier} /*onMouseLeave={() => this.handleBlurData(ele)}*/>
                                                                <td>{
                                                                    ele.isEdit ?
                                                                        <Autocomplete
                                                                            noOptionsText={`${t("CommonText.NoOption")}`}
                                                                            size={"small"}
                                                                            value={ele.equipmentValue}
                                                                            getOptionLabel={(item) => item?.name || ""}
                                                                            options={EquipmentDropdownList ?? []}
                                                                            name="equipment"
                                                                            onChange={(e, value) => this.handleInputChangeData(e, ele.identifier, value?.shipEquipmentId, value)}
                                                                            renderInput={(params) => (
                                                                                <TextField
                                                                                    {...params}
                                                                                    placeholder={t("EquipmentManagementScreenContent.SelectEquipment")}
                                                                                    margin="normal"
                                                                                />
                                                                            )}
                                                                        /> : ele?.equipmentName}
                                                                </td>
                                                                <td>
                                                                    {
                                                                        ele.isEdit ?
                                                                            <Autocomplete
                                                                                multiple
                                                                                disabled={ele?.shipEquipmentId ? false : true}
                                                                                noOptionsText={`${t("CommonText.NoOption")}`}
                                                                                size={"small"}
                                                                                value={ele.serviceTypes}
                                                                                getOptionLabel={(item) => item?.serviceType || ""}
                                                                                options={this.state.serviceTypeOptions ?? []}
                                                                                name="equipment"
                                                                                onChange={(e, value) => this.handleInputChangeType(e, ele.identifier, value, ele)}
                                                                                // onBlur={(e, value) => this.handleBlueServiceType(e, ele.identifier, value, ele)}
                                                                                renderInput={(params) => (
                                                                                    <TextField
                                                                                        {...params}
                                                                                        placeholder={t("EquipmentManagementScreenContent.SelectServiceType")}
                                                                                        margin="normal"
                                                                                    />
                                                                                )}
                                                                            />
                                                                            :
                                                                            ele?.serviceTypes?.map(item => item.serviceType).join(', ')
                                                                    }
                                                                </td>
                                                                {
                                                                    ele.cost?.length > 0 && ele.cost?.map(x => {
                                                                        return ele.isEdit ? <td><input type="number" disabled={(ele?.shipEquipmentId && ele?.serviceTypes?.length > 0) ? false : true} autoComplete="off" placeholder={x.lookUpName} name={x.lookUpName} value={x?.cost} onChange={(e) => { this.handleInputChangeZoneData(e, ele, x, ind) }} className="form-control"></input></td> : <td>{x?.cost}</td>
                                                                    })
                                                                }
                                                                <td>
                                                                    <div className="text-center">
                                                                        {ele?.shipEquipmentId > 0 && <>
                                                                            <OverlayTrigger
                                                                                placement="bottom"
                                                                                delay={{ show: 250, hide: 400 }}
                                                                                overlay={this.renderedit()}
                                                                            >
                                                                                <i
                                                                                    className="fa fa-edit fa-lg click m-1 px-1"
                                                                                    onClick={() => this.handleEdit(ele.identifier, true, ele)}
                                                                                    aria-hidden="true"
                                                                                    style={{
                                                                                        color: " #1a3464",
                                                                                        fontSize: "1.8rem",
                                                                                        display: (ele.isEdit ? "none" : "")
                                                                                    }}
                                                                                ></i>
                                                                            </OverlayTrigger>
                                                                            <OverlayTrigger
                                                                                placement="bottom"
                                                                                delay={{ show: 250, hide: 400 }}
                                                                                overlay={this.rendersave()}
                                                                            >
                                                                                <i
                                                                                    className="fa fa-floppy-o fa-lg click m-1 px-1"
                                                                                    onClick={() => this.handleBlurData(ele)}
                                                                                    aria-hidden="true"
                                                                                    style={{
                                                                                        color: " #1a3464",
                                                                                        fontSize: "1.8rem",
                                                                                        display: (ele.isEdit ? "" : "none")
                                                                                    }}
                                                                                ></i>
                                                                            </OverlayTrigger>
                                                                            <OverlayTrigger
                                                                                placement="bottom"
                                                                                delay={{ show: 250, hide: 400 }}
                                                                                overlay={this.renderdelete()}
                                                                            >
                                                                                <i
                                                                                    className="fa fa-trash click m-1 px-2"
                                                                                    onClick={() =>
                                                                                        // this.handleDeleteData(ele, ind)
                                                                                        this.confirmDelete(ele, ind)
                                                                                    }
                                                                                    aria-hidden="true"
                                                                                    style={{
                                                                                        color: " #1a3464",
                                                                                        fontSize: "1.8rem",
                                                                                    }}
                                                                                ></i>
                                                                            </OverlayTrigger>
                                                                        </>}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    // onPaginatorChange(event, tableIdentier) {
    //   let _first = this.state.first;
    //   _first[tableIdentier] = event.first
    //   this.setState({
    //     first: _first
    //   });
    //   this.getData(tableIdentier, event.page + 1);
    // }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
function mapStateToProps(state) {
    return {
        EquipmentDropdownList: state.MasterScreenReducer.DropdownEquipmentList || [],
        LookupList: state.lookupReducer.LookupList,
    };
}
export default withTranslation()(withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ShipCostManagement)));
